var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.is,{tag:"component",staticClass:"transition-opacity duration-500",class:_vm.itemClass,attrs:{"to":_vm.item.url,"href":_vm.item.url}},_vm._l((_vm.item.components),function(component){return _c('ItemComponent',{key:`item-${component.id}`,attrs:{"component":component}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }